"use client"

const RouteDisplay = ({ routes, swapWithService, apiCallInProgress }) => {
  console.log(routes);
  return (
    <div>
      {routes.map((route, index) => (
        <div key={index} className="rango-timeline">
          <div className="fixed-item">
            <span>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
              {/* Add swaps.fee[x].amount (string) using BigNumber */}
              {route.swaps.reduce((acc, swap) => acc + parseFloat(swap.fee?.reduce((a, f) => a + parseFloat(f.amount), 0)), 0).toFixed(6)} {route.swaps[0]?.from.symbol}
            </span>
            <hr />
            <span>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
              </svg>
              {/* Add swaps.timeStat.avg */}
              ~Duration {route.swaps.reduce((acc, swap) => acc + (swap.timeStat?.avg || 0), 0)} sec
            </span>
          </div>
          <div className="scroll-item">
            {route.swaps.map((swap, swapIndex) => (
              <div className="d-flex align-items-center" key={swapIndex}>
                {swapIndex === 0 && (
                  <div className="item">
                    <div className="icon">
                      <img src={swap.from.logo || "/placeholder.svg"} alt={swap.from.symbol} />
                    </div>
                    <div>
                      <div className="text">
                        {Number.parseFloat(swap.fromAmount).toFixed(3)} {swap.from.symbol}
                      </div>
                      <div className="text-sm">on {swap.from.blockchain}</div>
                    </div>
                  </div>
                )}
                <div className="item-connect--between">
                  <div className="divider" />
                  <div className="icon">
                    <img src={swap.swapperLogo || "/placeholder.svg"} alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src={swap.to.logo || "/placeholder.svg"} alt="" />
                  </div>
                  <div>
                    <div className="text">
                      {Number.parseFloat(swap.toAmount).toFixed(6)} {swap.to.symbol}
                    </div>
                    <div className="text-sm">on {swap.to.blockchain}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div>
            <button
              onClick={() => swapWithService(route)}
              className={`btn-sm select-route ${apiCallInProgress ? "rango-connect--wallet-disabled" : "rango-connect--wallet"}`}
            >
              Confirm Route
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default RouteDisplay
